// extracted by mini-css-extract-plugin
export default {"admin-page":"AdminPage_admin-page__UR3JI"};